export default __webpack_public_path__ + "static/media/terrasense-metric-icons.220b5833.png";